import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const guestSecurityDepositNotificationMessages = {
  [AutomationEventTypes.SecurityDepositCreated]: {
    subject: 'Security Deposit Created for Your Stay at *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      A security deposit has been created for your stay at *|RENTAL:NAME|*.

      Stay Details:
      Property: *|RENTAL:NAME|*
      Check-in: *|INQUIRY:ARRIVE|*
      Check-out: *|INQUIRY:DEPART|*

      View your security deposit: *|SECURITY_DEPOSIT:LINK|*

      We will let you know if any action is needed on your side.
    `,
  },
  [AutomationEventTypes.SecurityDepositAuthorized]: {
    subject: 'Security Deposit Authorized for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      Your security deposit for *|RENTAL:NAME|* has been authorized and the funds are now being held.

      Stay Details:
      Property: *|RENTAL:NAME|*
      Check-in: *|INQUIRY:ARRIVE|*
      Check-out: *|INQUIRY:DEPART|*

      View your security deposit: *|SECURITY_DEPOSIT:LINK|*

      If you have any questions, please contact us at *|RENTAL:PHONE|*.
    `,
  },
  [AutomationEventTypes.SecurityDepositCaptured]: {
    subject: 'Security Deposit Captured for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      Your security deposit for *|RENTAL:NAME|* has been captured and the funds have been charged.

      Stay Details:
      Property: *|RENTAL:NAME|*
      Check-in: *|INQUIRY:ARRIVE|*
      Check-out: *|INQUIRY:DEPART|*

      View your security deposit: *|SECURITY_DEPOSIT:LINK|*

      Please contact us if you need any additional details.
    `,
  },
  [AutomationEventTypes.SecurityDepositRefunded]: {
    subject: 'Security Deposit Refunded for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      Your security deposit for *|RENTAL:NAME|* has been refunded.

      Stay Details:
      Property: *|RENTAL:NAME|*
      Check-in: *|INQUIRY:ARRIVE|*
      Check-out: *|INQUIRY:DEPART|*

      View your security deposit: *|SECURITY_DEPOSIT:LINK|*

      Please allow your payment provider time to post the refund to your account.
    `,
  },
  [AutomationEventTypes.SecurityDepositCanceled]: {
    subject: 'Security Deposit Canceled for *|RENTAL:NAME|*',
    message: `
      Dear *|GUEST:NAME|*,

      Your security deposit for *|RENTAL:NAME|* has been canceled and any authorization hold has been released.

      Stay Details:
      Property: *|RENTAL:NAME|*
      Check-in: *|INQUIRY:ARRIVE|*
      Check-out: *|INQUIRY:DEPART|*

      View your security deposit: *|SECURITY_DEPOSIT:LINK|*

      Please contact us if you need any additional details.
    `,
  },
}
